import {
  IconAffirm,
  IconAmex,
  IconDiners,
  IconDiscover,
  IconKlarna,
  IconPayPal,
  IconVisa,
} from 'hem-ui';
import { IconMastercard } from 'hem-ui/src/components/IconMastercard';
import React from 'react';

import { root } from './PaymentOptions.module.scss';

enum Payment {
  Affirm,
  Amex,
  Diners,
  Discover,
  Mastercard,
  Klarna,
  Visa,
  PayPal,
}

const AvailablePaymentOptions = {
  'EU B2C': [Payment.Visa, Payment.Mastercard, Payment.Amex, Payment.PayPal],
  'UK B2C': [Payment.Visa, Payment.Mastercard, Payment.Amex, Payment.PayPal],
  'EU B2B': [Payment.Visa, Payment.Mastercard, Payment.Amex, Payment.PayPal],
  'US B2C': [
    Payment.Affirm,
    Payment.Visa,
    Payment.Mastercard,
    Payment.Amex,
    Payment.Discover,
    Payment.Diners,
    Payment.PayPal,
  ],
  'US B2B': [
    Payment.Visa,
    Payment.Mastercard,
    Payment.Amex,
    Payment.Discover,
    Payment.Diners,
    Payment.PayPal,
  ],
  'UK B2B': [
    Payment.Visa,
    Payment.Mastercard,
    Payment.Amex,
    Payment.Klarna,
    Payment.PayPal,
  ],
  'CA B2C': [
    Payment.Visa,
    Payment.Mastercard,
    Payment.Amex,
    Payment.Discover,
    Payment.Diners,
    Payment.PayPal,
  ],
};

const regionDifferentiator =
  process.env.GATSBY_REGION_REGION_DIFFERENTIATOR.replace(
    ' DEV',
    '',
  ) as keyof typeof AvailablePaymentOptions;

export function PaymentOptions() {
  return (
    <div className={root}>
      {AvailablePaymentOptions[regionDifferentiator].includes(Payment.Visa) && (
        <IconVisa className="block aspect-[85.60/53.98] h-6 overflow-hidden rounded border border-black-200" />
      )}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.Mastercard,
      ) && (
        <IconMastercard className="block aspect-[85.60/53.98] h-6 overflow-hidden rounded border border-black-200" />
      )}

      {AvailablePaymentOptions[regionDifferentiator].includes(Payment.Amex) && (
        <IconAmex className="block aspect-[85.60/53.98] h-6 overflow-hidden rounded" />
      )}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.Diners,
      ) && (
        <IconDiners className="block aspect-[85.60/53.98] h-6 overflow-hidden rounded border border-black-200" />
      )}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.Discover,
      ) && (
        <IconDiscover className="block aspect-[85.60/53.98] h-6 overflow-hidden rounded" />
      )}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.Affirm,
      ) && <IconAffirm className="block h-4" />}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.PayPal,
      ) && <IconPayPal className="block h-4" />}

      {AvailablePaymentOptions[regionDifferentiator].includes(
        Payment.Klarna,
      ) && <IconKlarna className="block h-4" />}
    </div>
  );
}
